import { NodeElement } from './node-element';

export class NodeMoreLess extends NodeElement {
    constructor(hidableKey: string, indent: number) {
        super(null, null);
        this.hidableKeys = [hidableKey];
        this.indent = indent;
    }
}
